/**
 * Catalog Check Item used by the Filter Catalog
 */
export class CheckItem {
  constructor(
    public id: string,
    public value: string,
    public checked: boolean,
    public title: string,
    public tooltip: string // optional field
  ) {}
}
